import React, { createContext, useContext, useEffect } from "react";

const ThemeContext = createContext(null);

// OpticSwap is DARK-ONLY. `:root` (index.css) is the dark theme; the opt-in `.light`
// class must NEVER be present — including for visitors whose OS is in light mode or who
// had a light/system preference saved from the old theme switcher.
export function ThemeProvider({ children }) {
  useEffect(() => {
    document.documentElement.classList.remove("light");
    try { localStorage.setItem("os_theme", "dark"); } catch (e) { /* ignore */ }
  }, []);
  return (
    <ThemeContext.Provider value={{ pref: "dark", resolved: "dark", setTheme: () => {} }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
